import request, { getRandomParam } from '../request';
// 【选项】获取船舶产权公司选项
export function getShipOwnerApi() {
    return request.post('/ship/options/owner', getRandomParam());
}
// 【选项】获取船产权方式选项
export function getShipOwnershipTypeApi() {
    return request.post('/ship/options/ownership/type', getRandomParam());
}
// 【选项】获取造船厂选项
export function getShipyardApi() {
    return request.post('/ship/options/shipyard', getRandomParam());
}
// 【选项】获取船舶种类选项
export function getShipTypeApi() {
    return request.post('/ship/options/type', getRandomParam());
}
// 【选项】获取船舶舱内甲板层数选项
export function getShipDeckTypeApi() {
    return request.post('/ship/options/type/deck', getRandomParam());
}
// 【选项】获取船舶舱型选项
export function getShipHoldTypeApi() {
    return request.post('/ship/options/type/hold', getRandomParam());
}
// 【选项】获取按结构划分的船舶类型选项
export function getShipStructureTypeApi() {
    return request.post('/ship/options/type/structure', getRandomParam());
}
// 【选项】获取按可装货类划分的船舶类型选项
export function getShipCargoTypeApi() {
    return request.post('/ship/options/type/cargo', getRandomParam());
}
// 【选项】获取船级社选项
export function getShipClassificationSocietyApi() {
    return request.post('/ship/options/society/classification', getRandomParam());
}
// 【选项】获取船东互保协会选项
export function getShipPniClubApi() {
    return request.post('/ship/options/club/pni', getRandomParam());
}
// 【选项】获取特色证书选项
export function getShipCharacteristicCertApi() {
    return request.post('/ship/options/cert/characteristic', getRandomParam());
}
// 【选项】获取油类选项
export function getShipOilApi() {
    return request.post('/ship/options/oil', getRandomParam());
}
// 【选项】获取主机航速选项
export function getShipSpeedApi() {
    return request.post('/ship/options/speed', getRandomParam());
}
// 【选项】获取运行模式选项
export function getShipWorkingModeApi() {
    return request.post('/ship/options/mode/working', getRandomParam());
}
// 【船舶】搜索平台所存在的原始船舶数据
export function shipSearchApi(params) {
    return request.post('/ship/search', params);
}
// 【船舶】搜索平台所存在的原始船舶数据
export function shipDetailApi(id) {
    return request.post('/ship/detail', { id });
}
// 【船舶】添加新船规/船舶数据
export function addShipApi(params) {
    return request.post('/ship/add', params);
}
// 【船舶】获取当前企业所拥有的船舶数据
export function getOwnedShipApi(params) {
    return request.post('/ship/owned', params);
}
// 【船舶】船盘编辑/新增船盘
export function addShipVoyageApi(params) {
    return request.post('/ship/voyage/add', params);
}
// 【船盘】获取船盘列表
export function shipVoyageOwnedApi(params) {
    return request.post('/ship/voyage/owned', params);
}
// 【船舶】收藏船规/船舶数据
export function shipCopyApi(id) {
    return request.post('/ship/copy', { id });
}
// 【船盘】获取船盘所有信息
export function shipVoyageInformationAllApi(para) {
    return request.post('/ship/voyage/information/all', para);
}
// 【货盘】发布货盘/重新发布货盘
export function shipVoyagePublishApi(params) {
    return request.post('/ship/voyage/publish', params);
}
// 【船舶】将船规/船舶数据放入回收站
export function shipTrashApi(id) {
    return request.post('/ship/trash', { id });
}
// 【船舶】恢复船规/船舶数据
export function shipRecycleApi(id) {
    return request.post('/ship/recycle', { id });
}
// 【船舶】强制删除船规/船舶数据
export function shipDeleteApi(id) {
    return request.post('/ship/delete', { id });
}
// 【船盘】将船盘放入回收站
export function shipVoyageTrashApi(id) {
    return request.post('/ship/voyage/trash', { id });
}
// 【船盘】强制删除船盘
export function shipVoyageDeleteApi(id) {
    return request.post('/ship/voyage/delete', { id });
}
// 【船盘】恢复船盘
export function shipVoyageRecoverApi(id) {
    return request.post('/ship/voyage/recover', { id });
}
// 【船舶】获取船规/船舶最新操作日志
export function shipLogLatestApi(id, type) {
    return request.post('/ship/log/latest', { id, type });
}
// 【船舶】获取指定船舶的主权宣示历史
export function shipHistoryApplicationOwnershipApi(id) {
    return request.post('/ship/history/application/ownership', { id });
}
// 【船舶】获取指定船舶的主权宣示历史
export function shipHistoryApplicationApi(id, type) {
    return request.post('/ship/history/application/ownership', { id, type });
}
// 【船舶】获取当前月船盘编辑日志
export function shipHistoryVoyageApi(id) {
    return request.post('/ship/history/voyage/edit', { id });
}
// 主权宣示
export function shipOwnershipApplyApi(options) {
    return request.post('/ship/ownership/apply', options);
}
// 【船盘】获取船盘发布时的设置信息
export function shipVoyageInfoPublishedApi(para) {
    return request.post('/ship/voyage/information/published', para);
}
// 【货盘】获取与货盘匹配的最新船盘
export function shipVoyageMatchedLatestApi(id, shipownerId) {
    return request.post('/ship/voyage/matched/latest', { voyageId: id, shipownerId: shipownerId });
}
